import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService, BackendResponse } from 'auth/src/public-api';

export interface BrandingData {
    clientName?: string;
    platformUrl?: string;
    apiUrl?: string;
    logo?: string;
    loginScreenImage?: string;
    themeScss?: string;
    favicon16x16?: string;
    favicon32x32?: string;
    [key: string]: any; // Permite outros campos customizados
}

export interface BrandingResult {
    found: boolean;
    configId?: number;
    configName?: string;
    branding?: BrandingData;
}

export interface DomainCheckResult {
    found: boolean;
    configId?: number;
    configName?: string;
    branding?: BrandingData;
}

@Injectable({
    providedIn: 'root'
})
export class BrandingService {

    private readonly LAST_EMAIL_KEY = 'sso_last_email';

    constructor(private _backendService: BackendService) {}

    public getBrandingByHostname(hostname: string): Observable<BackendResponse<BrandingResult>> {
        return this._backendService.get<BrandingResult>(
            'getBrandingByHostname',
            [],
            [{ name: 'host', value: hostname }]
        );
    }

    public checkEmailDomain(email: string): Observable<BackendResponse<DomainCheckResult>> {
        return this._backendService.get<DomainCheckResult>(
            'checkEmailDomain',
            [],
            [{ name: 'email', value: email }]
        );
    }

    /**
     * Salva o último email usado para login no localStorage
     */
    public saveLastEmail(email: string): void {
        if (email && email.trim()) {
            localStorage.setItem(this.LAST_EMAIL_KEY, email.trim().toLowerCase());
        }
    }

    /**
     * Recupera o último email usado para login do localStorage
     */
    public getLastEmail(): string | null {
        return localStorage.getItem(this.LAST_EMAIL_KEY);
    }

    /**
     * Limpa o último email salvo (usado no logout)
     */
    public clearLastEmail(): void {
        localStorage.removeItem(this.LAST_EMAIL_KEY);
    }
}
